import angular from 'angular';

import Component from './calendar-event.component';

const CalendarEvent = angular
    .module('control-room.commons.data.components.calendar.components.calendar-event', [])
    .component('crCalendarEvent', Component);

export default CalendarEvent;
